import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Tooltip } from "@mui/material";
import api from "../api/axios";

const BestSellerCarousel = ({ categoryId, navigate }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [products._id]);
  useEffect(() => {
    if (!categoryId) return;

    api
      .get(`/products/best-sellers?category=${categoryId}`)
      .then((res) => setProducts(res.data.products || []))
      .catch(console.error);
  }, [categoryId]);

  if (!products.length) return null;

  return (
    <Paper
      sx={{
        mt: 5,
        p: 3,
        borderRadius: 2,
        border: "1px solid #e0e0e0",
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: 18,
          mb: 3,
        }}
      >
        🔥 Best Sellers in this category
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 3,
          overflowX: "auto",
          pb: 1,
          "&::-webkit-scrollbar": { height: 6 },
          "&::-webkit-scrollbar-thumb": {
            background: "#ddd",
            borderRadius: 4,
          },
        }}
      >
        {products.slice(0, 10).map((p, index) => (
          <Box
            key={p._id}
            sx={{
              minWidth: { xs: 140, sm: 180 },
              maxWidth: { xs: 140, sm: 180 },
              flexShrink: 0,
              cursor: "pointer",
              position: "relative",
              transition: "0.2s",
              "&:hover .title": {
                color: "#C7511F",
                textDecoration: "underline",
              },
            }}
            onClick={() => navigate(`/product/${p._id}`)}
          >
            <Box
              sx={{
                position: "absolute",
                top: 8,
                left: 8,
                bgcolor: "#C45500",
                color: "#fff",
                px: 1,
                py: 0.25,
                borderRadius: 1,
                fontSize: 12,
                fontWeight: 700,
                zIndex: 1,
              }}
            >
              #{index + 1}
            </Box>

            <Box
              sx={{
                height: 160,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 1.5,
              }}
            >
              <img
                src={p.imageUrl || "/placeholder.png"}
                alt={p.title}
                loading="lazy"
                style={{
                  maxHeight: 150,
                  maxWidth: 150,
                  objectFit: "contain",
                }}
              />
            </Box>

            <Tooltip title={p.title} arrow>
              <Typography
                className="title"
                sx={{
                  fontSize: 14,
                  lineHeight: "20px",
                  height: "40px",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  textOverflow: "ellipsis",
                  color: "#007185",
                  mb: 0.5,
                }}
              >
                {p.title}
              </Typography>
            </Tooltip>

            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 700,
                color: "#B12704",
              }}
            >
              ₹{Number(p.price || 0).toLocaleString("en-IN")}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default BestSellerCarousel;